import { useState, useEffect } from 'react';
import Axios from 'axios';
const useFetch = (endpoint, useQuery, { q, page, sort, filters, tag }) => {
    const [results, setResults] = useState({});
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            if (!useQuery || q || tag || filters) {
                const params = {};
                if (q) {
                    params.q = q.toString();
                }
                if (page) {
                    params.page = page;
                }
                if (sort) {
                    params.sort = sort.toString();
                }
                if (filters) {
                    Object.keys(filters).forEach(key => {
                        params[key] = filters[key];
                    });
                }
                if (tag) {
                    params.tag = tag;
                }
                try {
                    setLoading(true);
                    const { data } = await Axios({
                        method: 'POST',
                        url: endpoint,
                        data: params
                    });
                    setResults(data);
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
                finally {
                    setLoading(false);
                }
            }
        };
        fetchData();
    }, [endpoint, q, page, sort, filters, tag]);
    return { results, loading };
};
export default useFetch;
